
import { Card, CardContent } from "@/components/ui/card";
import { useReferralRules } from "@/hooks/useReferralRules";
import { Loader2, AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { ReferralRulesHeader } from "./components/ReferralRulesHeader";
import { ReferredBenefitsCard } from "./components/ReferredBenefitsCard";
import { ReferrerBenefitsCard } from "./components/ReferrerBenefitsCard";
import { ReferralRulesActions } from "./components/ReferralRulesActions";

interface ReferralRulesProps {
  isModuleEnabled?: boolean;
  previewMode?: boolean;
}

const ReferralRules = ({ isModuleEnabled = true, previewMode = false }: ReferralRulesProps) => {
  const {
    formData,
    isLoading,
    isSaving,
    hasUnsavedChanges,
    saveRule,
    resetForm,
    updateFormField
  } = useReferralRules();

  const handleSave = async () => {
    if (!isModuleEnabled) {
      return;
    }
    await saveRule();
  };

  if (isLoading) {
    return (
      <Card>
        <CardContent className="flex items-center justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span className="ml-2">Carregando regras...</span>
        </CardContent>
      </Card>
    );
  }

  const isDisabled = !isModuleEnabled;

  return (
    <div className="space-y-4">
      {hasUnsavedChanges && isModuleEnabled && (
        <Alert className="border-amber-200 bg-amber-50">
          <AlertCircle className="h-4 w-4 text-amber-600" />
          <AlertDescription className="text-amber-800">
            Você tem alterações não salvas. Clique em "Salvar Configurações" para aplicar as mudanças.
          </AlertDescription>
        </Alert>
      )}

      <Card className={isDisabled ? "opacity-60" : ""}>
        <ReferralRulesHeader />
        <CardContent className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ReferredBenefitsCard 
              formData={{
                referred_discount_type: formData.referred_discount_type,
                referred_discount_value: formData.referred_discount_value,
                referred_min_purchase: formData.referred_min_purchase
              }}
              updateFormField={updateFormField}
              isDisabled={isDisabled}
            />

            <ReferrerBenefitsCard 
              formData={{
                referrer_bonus_value: formData.referrer_bonus_value,
                referrer_multiplier: formData.referrer_multiplier,
                allow_bonus_accumulation: formData.allow_bonus_accumulation
              }}
              updateFormField={updateFormField}
              isDisabled={isDisabled}
            />
          </div>
          
          <ReferralRulesActions 
            onSave={handleSave}
            onReset={resetForm}
            isSaving={isSaving}
            hasUnsavedChanges={hasUnsavedChanges}
            isModuleEnabled={isModuleEnabled}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default ReferralRules;
